import React from 'react'

import { useTranslation } from 'react-i18next'

import { Search } from '@/Atomic/Molecules/Inputs/Search'

interface SearchBarProps {
  debouncer: (value: string) => void
  setSearchKey: React.Dispatch<React.SetStateAction<string>>
  showSearchResults: () => void
}

export const SearchBar: React.FC<SearchBarProps> = ({
  debouncer,
  setSearchKey,
  showSearchResults,
}) => {
  const { t } = useTranslation()
  return (
    <Search
      name="search-bar"
      placeholder={t('search.placeHolder')}
      searchWrapperClassName="dxp-topbar-search"
      bgColor="white"
      onChange={({ target: { value } }) => {
        debouncer(value)
        setSearchKey(value)
      }}
      onFocus={showSearchResults}
    />
  )
}
